// material-ui
import AddIcon from '@mui/icons-material/Add'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { Badge, Box, CardActions, List, ListItemButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useParams } from 'react-router-dom'

import WatchLaterTwoToneIcon from '@mui/icons-material/WatchLaterTwoTone'
import { Avatar, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import RedQuickInputTags from 'components/RedQuickInputTags'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import { gridSpacing } from 'store/constant'
import TitleService, { GetTimeSince } from 'title-service'
import SecondaryAction from 'ui-component/cards/CardSecondaryAction'
import SubCard from 'ui-component/cards/SubCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { MediaStatus } from 'features/enumerations'

// assets
import Busy from 'components/Busy'
import SeriesForm from 'components/SeriesForm'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_approvalRequest } from 'features/approvalRequest/approvalRequest-slice'
import * as autoThunks from 'features/auto-thunks'
import {
  get_all_series,
  get_selected_series,
  is_series_busy,
  setSelectedseries,
} from 'features/series/series-slice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let series_list = useSelector(get_all_series)
  let series_busy = useSelector(is_series_busy)
  let series = useSelector(get_selected_series)
  let approvalRequest_list = useSelector(get_all_approvalRequest)
  const [newMedia, setNewMedia] = React.useState(null)
  const [newMediaValid, setNewMediaValid] = React.useState(null)
  const [newMediaDirty, setNewMediaDirty] = React.useState(null)
  const [newMediaTags, setNewMediaTags] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [isUploading, setIsUploading] = React.useState(null)
  const [currentSeries, setCurrentSeries] = React.useState(null)
  const [currentSeriesValid, setCurrentSeriesValid] = React.useState(null)
  const [currentSeriesDirty, setCurrentSeriesDirty] = React.useState(null)
  const [progressContext, setProgressContext] = React.useState(null)
  const [thumbnails, setThumbnails] = React.useState(null)
  const [thumbnailsDirty, setThumbnailsDirty] = React.useState(null)
  const [mode, setMode] = React.useState(null)
  const [mediaResourceRandom, setMediaResourceRandom] = React.useState(null)
  const [titleMediaLocation, setTitleMediaLocation] = React.useState(null)
  const [titleTransparentLocation, setTitleTransparentLocation] =
    React.useState(null)
  const [titleMediaImageLocation, setTitleMediaImageLocation] =
    React.useState(null)
  const [tags, setTags] = React.useState(null)
  const [tagsDirty, setTagsDirty] = React.useState(null)
  const [genre, setGenre] = React.useState(null)
  const [genreDirty, setGenreDirty] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.get_content_house_series({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id, contextId, progressContext])
  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.load_series_approval_requests({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    function on_set_selected_series() {
      let item = get_current_model()
      if (item) {
        setTags((item.tags || []).map((v) => v.name).filter((x) => x))
        setGenre((item.genre || []).map((v) => v.name).filter((x) => x))
        setGenreDirty(null)
        setTagsDirty(null)
      } else {
        setTags([])
        setGenre([])
        setGenreDirty(null)
        setTagsDirty(null)
      }
    }
    on_set_selected_series()
  }, [get_current_model()?.id])

  function getSeries(): any {
    return (series_list || []).filter((x) => {
      return x.owner === params.id
    })
  }

  function getApprovalRequestItem(): any {
    let item = approvalRequest_list.find(
      (x) => x?.media?.id === series?.id || x?.series?.id === series?.id,
    )

    return item
  }

  function get_current_model(): any {
    let updates: any = {}
    if (titleMediaLocation) {
      updates.titleMediaLocation = titleMediaLocation
    }
    if (titleTransparentLocation) {
      updates.titleTransparentLocation = titleTransparentLocation
    }
    if (titleMediaImageLocation) {
      updates.titleMediaImageLocation = titleMediaImageLocation
    }
    return {
      ...(series || {}),
      ...(currentSeries || {}),
      ...updates,
    }
  }

  function series_form(storeSeries: any): any {
    return (
      <>
        <SeriesForm
          form={get_current_model()}
          page={undefined}
          context={{
            titleMediaUrl: {
              title: 'Serios Intro',
              componentTitle: 'Serios Intro',
              accept: 'video/mp4,video/x-m4v,video/*',
              uploadOnce: false,
              limit: 1,
              description: 'Upload your series intro clip.',
              contextId: contextId,
              storageLocation: `media/${params?.id}/media_mediaRel`,
              video: true,
              onStorageLocation: (location: string) => {
                setTitleMediaLocation(location)
              },
            },
            titleMediaImageUrl: {
              image: true,
              title: 'Series Coverage Image',
              componentTitle: 'Series Coverage Image',
              contextId: contextId,
              aspectRatio: 16 / 9,
              limit: 1,
              storageLocation: `media/${params?.id}/titleMediaImage`,
              description: 'Upload cover image for series',
              maxSize: 4000,
              onStorageLocation: (location: string) => {
                setTitleMediaImageLocation(location)
              },
            },
            titleTransparentUrl: {
              image: true,
              title: 'Series Title Image',
              componentTitle: 'Series Title Image',
              contextId: contextId,
              aspectRatio: 16 / 9,
              limit: 1,
              description: 'Upload title image for series',
              storageLocation: `media/${params?.id}/titleTransparent`,
              maxSize: 800,
              onStorageLocation: (location: string) => {
                setTitleTransparentLocation(location)
              },
            },
            id: contextId,
          }}
          onUpdate={(form, valid, dirty) => {
            setCurrentSeries(form)
            setCurrentSeriesDirty(dirty)
            setCurrentSeriesValid(valid)
          }}
        />
        <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
          {TitleService('Genre')}
        </Typography>
        <Typography variant="subtitle">
          {' '}
          e.g. :{TitleService('Action & Adventure')},&nbsp;
          {TitleService('Anime')},&nbsp;
          {TitleService('Classic')},&nbsp;
          {TitleService('Dramas')}
        </Typography>
        <RedQuickInputTags
          value={genre || []}
          onUpdate={(data) => {
            setGenre(data)
            setGenreDirty(true)
            setCurrentSeriesDirty(true)
            setCurrentSeriesValid(
              currentSeriesValid == null ? true : currentSeriesValid && true,
            )
          }}
        />
        <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
          {TitleService('Tags')}
        </Typography>
        <RedQuickInputTags
          value={tags || []}
          onUpdate={(data) => {
            setTags(data)
            setTagsDirty(true)
            setCurrentSeriesDirty(true)
            setCurrentSeriesValid(
              currentSeriesValid == null ? true : currentSeriesValid && true,
            )
          }}
        />

        {currentSeriesValid && !isUploading && currentSeriesDirty && (
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="flex-end">
              <AnimateButton>
                <Button
                  variant="contained"
                  disabled={
                    !(currentSeriesValid && !isUploading && currentSeriesDirty)
                  }
                  onClick={async () => {
                    await dispatch(storeSeries)
                    setTitleMediaLocation(null)
                    setTitleMediaImageLocation(null)
                    setTitleTransparentLocation(null)
                  }}
                >
                  {TitleService('Submit')}
                </Button>
              </AnimateButton>
            </Stack>
          </Grid>
        )}
      </>
    )
  }

  let output_series_form = series_form(
    autoThunks.storeSeriesForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      series: (() => {
        function _(): any {
          return get_current_model()
        }
        return _()
      })(),
      genre: (() => {
        function _genre(): any {
          return genre || []
        }
        return _genre()
      })(),
      tags: (() => {
        function _tags(): any {
          return tags || []
        }
        return _tags()
      })(),
    }),
  )

  function series_list_component(): any {
    return (
      <List component="nav" aria-label="main mailbox folders">
        {getSeries().map((serie, index) => {
          let thumbnail = serie?.titleMediaImageUrl
          let statusColor = theme.palette.grey[500]
          let statusTitle = ''
          let isRejected = false
          let isApproved = false
          if (serie) {
            if (serie?.mediaStatus === MediaStatus.Unreviewed) {
              statusColor = theme.palette.info.main
              statusTitle = TitleService('Unreviewed')
            } else if (serie?.mediaStatus === MediaStatus.Reviewed) {
              statusColor = theme.palette.success.main
              statusTitle = TitleService('Reviewed')
            }
            isApproved = serie?.mediaStatus === MediaStatus.Approved
            isRejected = serie?.mediaStatus === MediaStatus.Rejected
          }
          return (
            <ListItemButton
              key={index}
              selected={serie?.id === series?.id}
              onClick={() => {
                dispatch(setSelectedseries(serie.id))
                setContextId(uuid())
                setCurrentSeries({})
                setTags(null)
                setGenre(null)
                setTagsDirty(null)
                setGenreDirty(null)
              }}
            >
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Box sx={{ position: 'relative' }}>
                      <Badge
                        overlap="circular"
                        badgeContent={
                          <FiberManualRecordIcon
                            sx={{
                              color: statusColor,
                              fontSize: '0.875rem',
                            }}
                          />
                        }
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                      >
                        <Avatar
                          alt={serie.name}
                          title={statusTitle}
                          src={thumbnail}
                        />
                      </Badge>
                    </Box>
                  </Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography
                      align="left"
                      component="div"
                      variant="subtitle1"
                    >
                      {serie?.name}
                    </Typography>
                    <Typography
                      align="left"
                      component="div"
                      style={{
                        whiteSpace: 'nowrap',
                        maxWidth: 200,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                      variant="subtitle2"
                    >
                      {serie?.description}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    justifyContent="flex-end"
                    alignContent="flex-end"
                    justifyItems="flex-end"
                    alignItems="flex-end"
                  >
                    <Stack
                      direction="column"
                      justifyContent="flex-end"
                      alignContent="flex-end"
                      justifyItems="flex-end"
                      alignItems="flex-end"
                    >
                      {isApproved && SC.approveCheckSmall()}
                      {isRejected && SC.errorSignSmall()}
                      {!isRejected && (
                        <Typography align="left" variant="caption">
                          <WatchLaterTwoToneIcon
                            sx={{
                              fontSize: '0.875rem',
                              marginRight: 0.2,
                              verticalAlign: 'sub',
                            }}
                          />
                          {GetTimeSince(serie)}
                        </Typography>
                      )}
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </ListItemButton>
          )
        })}
      </List>
    )
  }

  let output_series_list_component = series_list_component()

  function main_card(
    form: any,
    serieslist: any,
    requestSeriesApproval: any,
    cancelSeiesApproval: any,
  ): any {
    return (() => {
      return (
        <Grid container spacing={gridSpacing}>
          <Busy />
          <Grid item xs={12} sm={6} md={4}>
            <SubCard
              title={TitleService('Series')}
              secondary={
                <SecondaryAction
                  icon={
                    <AddIcon
                      onClick={() => {
                        dispatch(setSelectedseries(null))
                        setCurrentSeries({})
                        setContextId(uuid())
                      }}
                    />
                  }
                />
              }
            >
              {serieslist}
            </SubCard>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <SubCard title={TitleService('Series')}>
              {series && series.id && (
                <>
                  <CardActions>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={2}
                    >
                      <Grid item item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="flex-end"
                          spacing={2}
                        >
                          {series?.mediaStatus === MediaStatus.Unreviewed && (
                            <Grid item>
                              <Button
                                variant="contained"
                                disabled={series_busy}
                                onClick={async () => {
                                  await dispatch(requestSeriesApproval)
                                }}
                              >
                                {TitleService('Request Approval')}
                              </Button>
                            </Grid>
                          )}
                          {series?.mediaStatus === MediaStatus.Rejected && (
                            <Grid item>
                              <Button
                                variant="contained"
                                disabled={series_busy}
                                onClick={async () => {
                                  await dispatch(requestSeriesApproval)
                                }}
                              >
                                {TitleService('Re-request Approval')}
                              </Button>
                            </Grid>
                          )}
                          {series?.mediaStatus ===
                            MediaStatus.RequestingApproval && (
                            <Grid item>
                              <Button
                                variant="outline"
                                disabled={series_busy}
                                onClick={async () => {
                                  await dispatch(cancelSeiesApproval)
                                }}
                              >
                                {TitleService('Cancel Request')}
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item>
                            {series?.mediaStatus === MediaStatus.Rejected &&
                              SC.errorSign()}
                          </Grid>
                          <Grid item>
                            <Typography variant="h4" sx={{ m: 0 }}>
                              {series?.mediaStatus === MediaStatus.Rejected &&
                                TitleService('Rejected')}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography variant="h5" sx={{ m: 0 }}>
                              {series?.mediaStatus === MediaStatus.Rejected &&
                                TitleService(
                                  getApprovalRequestItem()?.rejectionReason,
                                )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                </>
              )}
              {form}
            </SubCard>
          </Grid>
        </Grid>
      )
    })()
  }

  let output_main_card = main_card(
    output_series_form,
    output_series_list_component,
    autoThunks.requestSeriesContentApprovalForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      seriesId: (() => {
        function getSeriesId(): any {
          return series?.id
        }
        return getSeriesId()
      })(),
    }),
    autoThunks.cancelSeriesContentApprovalForContentHouse({
      fire_user: claims?.user,
      contentHouseId: params?.id,
      seriesId: (() => {
        function getSeriesId(): any {
          return series?.id
        }
        return getSeriesId()
      })(),
    }),
  )

  return output_main_card
}
